import serverconfig from '@/api/server.config';
const HALL_WECHAT_API = serverconfig.API;

/**
 * 通过fileId获取完整的图片URL
 * @param {string|number} fileId - 文件ID
 * @returns {string} 完整的图片URL
 */
export function imageFullUrl(fileId) {
  if (!fileId) {
    return '';
  }
  return `${HALL_WECHAT_API}/biz/file/view?fileId=${fileId}`;
}

